<template>
  <div class="search-block">
    <!-- orgs lookup dropdown -->
    <div :class="['dropdown hp-dropdown hp-dropdown--input search-block-dd', showOrgLookDropdown]" v-show="orgsFound">
      <div class="dropdown-menu" role="menu">
        <div
            class="dropdown-content is-paddingless"
            @mouseleave.self="hideBusinessAutoComplete"
        >
          <a
              v-for="(business,index) in businesses"
              :key="index"
              @click.prevent="selectOrg(business)"
              href="#"
              :ref="`${business.id}`"
              class="dropdown-item has-text-left"
              v-html="business.name"
          ></a>
          <div class="dropdown-item">
            <a @click.prevent="forwardSearch(searchString)" class="hp-btn-primary is-fullwidth button">
              Show all results
              &nbsp;
              <img src="/static/img/arrows/arrow_right2_white.png">
            </a>
          </div>
        </div>
      </div>
    </div>

    <input
        autocomplete="off"
        @keyup.enter="forwardSearch(searchString)"
        :value="searchString"
        @input="searchString=$event.target.value"
        @keyup="orgLookup()"
        @focus="$emit('focus')"
        class="input hp-input search-block-field"
        type="text"
        placeholder="Find businesses you can trust…"
        ref="searchField"
    />

    <slot></slot>
  </div>
</template>
<script>
import {search} from '@/mixins'

export default {
  name: 'BusinessSearch',
  mixins: [search]
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

.search-block {
  flex-basis: 469px;
  margin-right: 25px;
  position: relative;

  .search-block-field {
    background: url("/static/img/magnifier/magnifier2_blue_dark.png") no-repeat left 13px center/15px;
    padding-left: 40px;
    height: 35px;
  }

  .dropdown-content {
    height: auto;

    .hp-btn-primary {
      font-size: 14px;
      font-weight: bold;
      text-transform: uppercase;
      height: 35px;

      img {
        width: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BusinessSearch.vue